export enum CertificateType {
    ALL = 'ALL',
    APPLICATION = 'APPLICATION',
    CATALOGUE = 'CATALOGUE',
}
